<template>
  <section class="panel pad">
    <div class="panel-head">
      <h2>规格索引缺口</h2>
      <div class="head-actions">
        <button type="button" class="btn ghost sm" @click="rebuild">重建全部索引</button>
        <button type="button" class="btn ghost sm" @click="load">刷新</button>
      </div>
    </div>
    <p v-if="message" class="ok">{{ message }}</p>
    <p v-if="error" class="error">{{ error }}</p>
    <p class="ok" v-if="gaps.count != null">共 {{ gaps.count }} 张（展示前 {{ gaps.items.length }}）</p>
    <div v-for="item in gaps.items" :key="item.card_id" class="list-item">
      <div>
        <strong>{{ item.name }}</strong>
        <span class="muted"> · {{ item.vendor || '未分类' }}</span>
        <span v-if="item.missing_memory" class="warn"> 缺显存</span>
        <span v-if="item.missing_fp16" class="warn"> 缺FP16</span>
      </div>
      <button type="button" class="btn ghost sm" @click="$emit('edit', item.card_id)">去编辑</button>
    </div>
  </section>
</template>

<script>
import { adminMetricsGaps, rebuildMetrics } from '../../api/platformService'

export default {
  name: 'AdminGaps',
  emits: ['edit'],
  data() {
    return {
      gaps: { count: 0, items: [] },
      error: '',
      message: ''
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    async load() {
      this.error = ''
      try {
        this.gaps = await adminMetricsGaps()
      } catch (err) {
        this.error = err.response?.data?.error || '加载缺口失败'
      }
    },
    async rebuild() {
      this.error = ''
      try {
        const result = await rebuildMetrics()
        this.message = `已重建 ${result.count} 张卡的规格索引`
        await this.load()
      } catch (err) {
        this.error = err.response?.data?.error || '重建失败'
      }
    }
  }
}
</script>
